import { render, staticRenderFns } from "./SVGIcon.vue?vue&type=template&id=6b9718c7"
import script from "./SVGIcon.vue?vue&type=script&lang=ts"
export * from "./SVGIcon.vue?vue&type=script&lang=ts"
import style0 from "./SVGIcon.vue?vue&type=style&index=0&id=6b9718c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports